import { Box, Button, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import filterContext from "../../../../app/providers/filter/filterContext";
import { transparentBlueButtonStyle, transparentOrangeButtonStyle } from "../../../../shared/styles/buttonStyles";
import { useDispatch, useSelector } from "react-redux";
import { setDraft } from "../../../../app/store/reservationSlice";

export default function EmptySearch() {

    const { t } = useTranslation();

    const { clearFilter } = useContext(filterContext);
    const dispatch = useDispatch();
    const {draft} = useSelector((state) => state.reservation.draft);

    const handleResetButton = () => {
        dispatch(setDraft({ ...draft,services: [] }));
        clearFilter();
    };

    return (
        <Box sx={{ padding: 2, textAlign: 'center' }}>
            <Typography variant="h6" component="h3" sx={{ marginBottom: 2, color: 'white' }}>
                {t("workshops.noWorkshopsFound")}
            </Typography>
            <Typography variant="body1" component="p" sx={{ marginBottom: 2, color: 'white' }}>
                {t("workshops.helpUserText")}
            </Typography>
            <Button
                sx={transparentOrangeButtonStyle}
                onClick={handleResetButton}
            >
                {t("filter.resetButton")}</Button>
        </Box>
    );
}